<template>
  <div class="modal integrations animated fadeIn">
    <div class="modal-background"></div>
    <span class="close-modal" @click="closeModal()">
      <i class="icon icon-close"></i>
    </span>

    <div class="modal-card animated fadeInUp">
      <div class="integrations-hero">
        <div class="left">
          <h2>{{ $t('integrations_modal.workpapers_integrations') }}</h2>
          <p>{{ $t('integrations_modal.integrations_message', { link: '<a href="https://zapier.com" target="_blank"><img src="/images/zapier.png"/></a>' }) }}</p>
          <a href="#" class="button is-primary is-medium explore">{{ $t('integrations_modal.integrations_all') }}</a>
        </div>
        <div class="right">
          <div class="api">
            <h4>{{ $t('integrations_modal.api_token_required') }}</h4>
            <p>{{ $t('integrations_modal.api_token_message') }}</p>
            <a href="/settings#/api" @click="closeModal()" class="button is-primary is-medium">{{ $t('integrations_modal.api_token_settings') }}</a>
          </div>
        </div>
      </div>

      <div class="break">
        <hr>
        <h3>{{ $t('integrations_modal.some_integration_examples') }}</h3>
      </div>

      <ul>
        <li>
          <div class="integration-card">
            <div class="logos">
              <img src="/images/integrations/slack.png"/>
              <span>+</span>
              <img src="/images/integrations/workpapers.png"/>
            </div>
            <h4>{{ $t('integrations_modal.slack') }}</h4>
            <p>{{ $t('integrations_modal.slack_message') }}</p>
            <a href="#" class="button is-primary is-medium">{{ $t('integrations_modal.use_this_zap') }}</a>
          </div>
        </li>
        <li>
          <div class="integration-card">
            <div class="logos">
              <img src="/images/integrations/trello.png"/>
              <span>+</span>
              <img src="/images/integrations/workpapers.png"/>
            </div>
            <h4>{{ $t('integrations_modal.trello') }}</h4>
            <p>{{ $t('integrations_modal.trello_message') }}</p>
            <a href="#" class="button is-primary is-medium">{{ $t('integrations_modal.use_this_zap') }}</a>
          </div>
        </li>
        <li>
          <div class="integration-card">
            <div class="logos">
              <img src="/images/integrations/dropbox.png"/>
              <span>+</span>
              <img src="/images/integrations/workpapers.png"/>
            </div>
            <h4>{{ $t('integrations_modal.dropbox') }}</h4>
            <p>{{ $t('integrations_modal.dropbox_message') }}</p>
            <a href="#" class="button is-primary is-medium">{{ $t('integrations_modal.use_this_zap') }}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Events: window.Events
    }
  },
  methods: {
    closeModal() {
      this.Events.$emit('modalClose', 'integrationsModal');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .integrations-hero {
    display: flex;
    .left {
      width: 50%;
      h2 {
        font-size: 20px;
        margin-bottom: 5px;
      }
      p {
        font-size: 14px;
        a {
          img {
            width: 57px;
            margin-bottom: -6px;
            margin-left: 3px;
            margin-right: 3px;
          }
        }
      }
      a.explore {
        margin: 20px 0 40px;
      }
    }
    .right {
      width: 50%;
      .api {
        float: right;
        margin: 20px 40px 0 0;
        border: 1px solid lighten($mutedblue, 12%);
        background: $white;
        border-radius: 4px;
        padding: 20px;
        max-width: 340px;
        h4 {
          font-weight: 600;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        a {
          margin-top: 20px;
        }
      }
    }
  }

  .break {
    margin: 30px 0;
    h3 {
      display: block;
      margin: -32px auto 30px;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
      padding: 0 20px;
      text-align: center;
      max-width: 360px;
      background: darken($eggshell, 2%);
    }
  }

  .modal .modal-card {
    background: none;
    border-radius: 0;
    margin-top: 42px;
    margin-bottom: 100px;
    box-shadow: none;
    width: 90%;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    li {
      z-index: 1;
      width: 33.3%;
      margin-bottom: 10px;
      .integration-card {
        min-height: 300px;
        text-align: center;
        background: $white;
        box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
        border-radius: 5px;
        padding: 30px;
        margin: 0 10px 10px 10px;
        position: relative;
        .logos {
          display: flex;
          justify-content: center;
          img {
            width: 80px;
            height: 80px;
            display: block;
            border-radius: 100px;
            border: 1px solid $mutedblue;
          }
          span {
            font-size: 1.8em;
            font-weight: 600;
            padding: 22px 1em 0;
            color: $mutedblue;
          }
        }
        h4 {
          margin: 20px 0;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        p {
          padding-bottom: 20px;
        }
        a {
          position: absolute;
          bottom: 30px;
          left: 20%;
          width: 60%;
          &.is-outlined:hover {
            background: $white;
            color: $green;
          }
        }
      }
      &:first-child {
        .integration-card {
          margin-left: 0;
        }
      }
      &:last-child {
        .integration-card {
          margin-right: 0;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// integrations-modal.vue?905b9e02